import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';

export const THUMBNAIL_ROUTE = `/${ENTITY_TO_PATH_MAP[ENTITY.THUMBNAIL]}`;
